import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { SettingsContext } from '../../contexts';
import { ActionButton } from '../../core/components';
import { downloadLookbook } from '../helpers';
import { getApiUrl } from '../../core/config/api';

const actionLabel = action => {
  switch (action) {
    case 'edit': return 'Edit';
    case 'download': return 'Download';
    case 'view': return 'View';
    default: return 'Action';
  }
};

const options = [
  { id: 'edit', name: 'Edit' },
  { id: 'view', name: 'View' },
  { id: 'download', name: 'Download' },
];

export function LookbookActionButton({ lookbook }) {
  const settings = useContext(SettingsContext);
  const history = useHistory();
  const [action, setAction] = useState(null);

  const updateItem = async () => {
    switch (action) {
      case 'edit':
        return history.push(`/lookbooks/${lookbook.id}?${settings.iframeQueryParams}`);
      case 'view':
        window.open(getApiUrl(`/api/pdfs/${lookbook.file_id}`), '_blank');

        return setAction(null);
      case 'download':
        downloadLookbook(lookbook.id, lookbook.file_id, lookbook.data?.lookbookName);
        setAction(null);
        return;
    }
  };

  return (
    <ActionButton
      {...{
        action,
        setAction,
        actionLabel: actionLabel(action),
        options,
        update: updateItem,
      }}
    />
  );
}
